var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.modalTitle,
        width: "80%",
        footer: null
      },
      on: { cancel: _vm.handleClose }
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.loading, tip: _vm.$t("lbl_loading") } },
        [
          _c("div", { staticClass: "preview" }, [
            _vm.fileType === "pdf"
              ? _c("div", { staticClass: "preview-toolbar" }, [
                  _c(
                    "div",
                    { staticClass: "preview-toolbar__container" },
                    [
                      _c(
                        "a-space",
                        { attrs: { size: "small" } },
                        [
                          _c(
                            "a-button-group",
                            [
                              _c(
                                "a-tooltip",
                                { attrs: { title: _vm.$t("lbl_zoom_in") } },
                                [
                                  _c("a-button", {
                                    attrs: {
                                      icon: "zoom-in",
                                      disabled: !_vm.isPdfLoaded
                                    },
                                    on: { click: _vm.zoomIn }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "a-tooltip",
                                { attrs: { title: _vm.$t("lbl_zoom_out") } },
                                [
                                  _c("a-button", {
                                    attrs: {
                                      icon: "zoom-out",
                                      disabled: !_vm.isPdfLoaded
                                    },
                                    on: { click: _vm.zoomOut }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "a-tooltip",
                                { attrs: { title: _vm.$t("lbl_print") } },
                                [
                                  _c("a-button", {
                                    attrs: {
                                      icon: "printer",
                                      disabled: !_vm.isPdfLoaded
                                    },
                                    on: { click: _vm.handlePrint }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "a-tooltip",
                                { attrs: { title: _vm.$t("lbl_download") } },
                                [
                                  _c("a-button", {
                                    attrs: {
                                      icon: "download",
                                      disabled: !_vm.isPdfLoaded
                                    },
                                    on: { click: _vm.handleDownload }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              : _vm._e(),
            _c(
              "div",
              {
                staticClass: "preview__content",
                style: {
                  transform: "scale(" + _vm.zoomLevel + ")",
                  transformOrigin: "top center"
                }
              },
              [
                _vm.fileType === "pdf" && _vm.pdfSrc
                  ? _vm._l(_vm.numPages, function(page) {
                      return _c("pdf", {
                        key: page,
                        ref: "pdfPage" + page,
                        refInFor: true,
                        staticClass: "preview__pdf-page",
                        attrs: { src: _vm.pdfSrc, page: page },
                        on: {
                          loaded: _vm.handlePdfLoaded,
                          error: _vm.handlePdfError
                        }
                      })
                    })
                  : _vm.isImage && _vm.previewUrl
                  ? _c("img", {
                      staticClass: "preview__image",
                      attrs: { src: _vm.previewUrl, alt: "Contract preview" }
                    })
                  : _vm._e()
              ],
              2
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }